module.exports = __webpack_public_path__ + "static/media/hollow_bar_AERO_hand_tall.17c173b8.svg";